<template>
  <div class="flex-col">
    <div
      class="banner cursor-pointer w-full flex flex-col lg:flex-row bg-bg_secondary mt-8 clickable border-t-2 border-b-2 border-gray-300">
      <div class="slider w-full lg:w-1/2">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item  in getImageData(1)" :key="item"><img @click="push_image" title="In and around the apartment"
              alt="In and around the apartment" class="w-full" :src="item"></swiper-slide>
        </swiper>
      </div>
      <div class="slider w-full lg:w-1/2 hidden lg:inline">
        <swiper :options="swiperOption" ref="mySwiper2">
          <swiper-slide v-for="item  in getImageData(2)" :key="item"><img @click="push_image2" title="In and around the apartment"
              alt="In and around the apartment" class="w-full" :src="item"></swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="text w-full px-4 lg:px-16 xxl:px-48 flex-col md:flex-row text-justify mt-8 items-start text-gray-600">
      <p class="w-full md:w-1/2 px-4 lg:px-16 xl:px-32 mb-4 md:mb-0">Unsere Ferienwohnung am Weiher liegt in ländlicher
        Umgebung mit dem Auto
        etwa 10 Minuten von Bad Oldesloe entfernt.<br>
        Neben einem großen Garten mit einem dazugehörigen Weiher, der nicht eingezäunt ist, bieten wir für bis zu 4
        Personen eine 70 qm2 große Ferienwohnung, die zur Erholung im Grünen einlädt.<br>
        Der großzügige Wohnbereich ist modern und liebevoll mit maritimen Dekorationsstücken ausgestattet. Eine im Jahr
        2019 neu eingerichtete Küche stehen neben Badezimmer und 2 Schlafzimmern zur freien Verfügung.</p>
      <div
        class="rezensionen w-full md:w-1/2 px-4 lg:px-16 xl:px-32 mb-4 md:mb-0 py-8 flex-col items-start bg-gray-200 rounded-lg">
        <a class="text-gray-500" target="_blank"
          href="https://www.airbnb.de/rooms/36585379?check_in=2019-09-19&check_out=2019-09-21&source_impression_id=p3_1566743451_wdQ6rhsEmNvIhGOi">Bewertung
          von {{rezensionen[rating_id].author}} - {{rezensionen[rating_id].ort}} auf Airbnb:</a>

        <p class="text-justify fair h-1/3 text-gray-600">
          {{rezensionen[rating_id].text}}
        </p>
        <a target="_blank"
          href="https://www.airbnb.de/rooms/36585379?check_in=2019-09-19&check_out=2019-09-21&source_impression_id=p3_1566743451_wdQ6rhsEmNvIhGOi">
          <h6 class="text-gray-400 text-sm fair text-left">Für genauere Informationen hier klicken.</h6>
        </a>
      </div>
    </div>
    <div class="text w-full flex-col px-4 lg:px-16 xxl:px-48 md:flex-row text-justify my-8 items-start text-gray-600">
      <p class="w-full md:w-1/2 px-4 lg:px-16 xl:px-32 mb-16 md:mb-0">Die Ferienwohnung befindet sich im OG unseres
        Hauses und
        bietet eine voll
        ausgestattete neue Küche.<br> Im Schlafzimmer 1 befindet sich ein Doppel-Bett 180x200cm. Im zweiten Schlafzimmer
        steht ein großes Bett 140x200cm.<br>
        Das Badezimmer bietet neben Waschbecken, Dusche und WC auch eine Badewanne. Natürlich ist der gesamte
        Wohnbereich mit WLAN ausgestattet.<br> Für die Abendunterhaltung nach einem spannenden Tag unterwegs steht im
        Wohnzimmer ein Flachbildfernseher, der mit einem Chromecast ausgestattet bereit für die Nutzung mit ihrem
        Netflix- oder Youtube-Account ist.<br>
        Weiterhin sind für Gäste ein eigener Zugang und Parkplatz enthalten.</p>
      <div class="located-near flex-col w-full md:w-1/2 px-4 lg:px-16 xl:px-32 text-gray-600">
        <div class="head text-center pb-4">
          <h5 class="play text-xl text-gray-600">In der Nähe von:</h5>
          <h6 class="xl-md text-gray-400">Located Near:</h6>
        </div>
        <div class="inner flex-col lg:flex-row justify-between">
          <div id="lubeck" class="flex justify-center w-full items-center py-4 lg:px-2 xl:px-4">
            <svg class="w-16 fill-current mr-8 hover:text-gray-600" data-name="Ebene 1"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 884 884">
              <path
                d="M456.8 604h29.4v59h-29.4zM397.8 604h29.5v59h-29.5zM338.9 604h29.4v59H339zM515.7 604H545v59h-29.4zM456.8 456.7h29.4v59h-29.4zM397.8 456.7h29.5v59h-29.5zM338.9 456.7h29.4v59H339zM515.7 456.7H545v59h-29.4zM427.3 294.6h29.4v29.5h-29.4zM147.3 324.1h29.5v44.2h-29.5zM88.4 456.7H118v59H88.4zM206.3 456.7h29.4v59h-29.4zM147.3 604h29.5v44.2h-29.5zM73.7 751.4h29.5v29.5H73.7zM221 751.4h29.5v29.5H221z" />
              <path
                d="M869.3 427.3a14.7 14.7 0 0 0 12.2-23L853 361.7l-116.4-320V0h-29.4v41.6l-116.4 320-16.2 24.4V265.2h-29.5v29.4h-29.4v-88.3h-29.5v29.4h-88.4v-29.4h-29.4v88.3h-29.5v-29.4h-29.5V386l-16.2-24.3L176.8 41.6V0h-29.5v41.6L31 361.6 2.5 404.4a14.7 14.7 0 0 0 4 20.4 14.6 14.6 0 0 0 8.3 2.5V545H0v29.5h14.8v117.9H0v29.4h14.8v132.6H0V884h884v-29.5h-14.7V722H884v-29.4h-14.7v-118H884v-29.4h-14.7zM839.8 545H604.1V427.2h235.7zM574.6 427.2v118H309.4v-118zM309.4 574.6h265.2v117.9H309.4zm307-198.1a14.3 14.3 0 0 0 1.5-3.1l104-286 104.1 286a14.2 14.2 0 0 0 1.6 3.1l14.2 21.3H602zM383 324.1a14.7 14.7 0 0 0 14.7-14.7v-44.2h88.4v44.2A14.7 14.7 0 0 0 501 324h44.3v73.7h-29.5v-44.2h-29.5v44.2h-29.4v-44.2h-29.5v44.2h-29.5v-44.2h-29.4v44.2h-29.5V324zM56.5 376.5a14.2 14.2 0 0 0 1.6-3.1l104-286 104 286a15.2 15.2 0 0 0 1.5 3.2l14.2 21.2H42.3zm-12.3 50.8H280V545H44.2zm0 147.3H280v117.9H44.2zm0 147.3H280v132.6H44.2zm265.2 0h265.2v132.6h-59V825a73.7 73.7 0 1 0-147.3 0v29.5h-58.9zm88.4 132.6V825a44.2 44.2 0 1 1 88.4 0v29.5zm442 0H604.1V722h235.7zm0-162H604.1v-118h235.7z" />
              <path
                d="M707.2 324.1h29.5v44.2h-29.5zM766.1 456.7h29.5v59h-29.5zM648.3 456.7h29.4v59h-29.4zM707.2 604h29.5v44.2h-29.5zM780.9 751.4h29.4v29.5H781zM633.5 751.4H663v29.5h-29.5z" />
            </svg>
            <div class="text flex-col">
              <h6 class="text-2xl md:text-lg">Lübeck</h6>
              <p class="text-sm text-gray-500 text-left">in 25min.</p>
            </div>
          </div>
          <div id="hamburg" class="flex justify-center w-full items-center py-4 lg:px-2 xl:px-4">
            <svg class="w-16 fill-current mr-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 248 249">
              <path
                d="M23 9v141h123s15-24 29 0h47V51s-21 9-30 4-13-6-22-18c-13 3-9 6-24 3s-25-15-29-27c-3 1-8 5-17 3S84 11 77 5c-6 4-16 12-24 13s-20-1-30-9zM23 161v68H4v16h240v-16h-22v-68H23zM23 229h199M76.6 161v68M92.4 161v68M127.5 161v68M160.9 161v68M196.9 161v68M77 5v145M30.5 150v11M70.9 150v11M146 150v11M175 150v11M216.2 150v11"
                fill="none" stroke="#718096" stroke-miterlimit="10" stroke-width="8" />
              <path fill="none" stroke="#718096" stroke-miterlimit="10" stroke-width="8"
                d="M241 172l-9 23v34M34 175h13v12H34zM101.2 229v-10H117v10M141 114h13v12h-13zM165 81h13v12h-13zM163 105h13v12h-13z" />
              <circle cx="34.3" cy="113.5" r="3.9" fill="#718096" />
              <circle cx="52.3" cy="126.4" r="3.9" fill="#718096" />
              <circle cx="44.6" cy="102" r="3.9" fill="#718096" />
              <circle cx="47" cy="78.5" r="3.9" fill="#718096" />
              <circle cx="57.5" cy="89.1" r="3.9" fill="#718096" />
              <circle cx="52.3" cy="64.6" r="3.9" fill="#718096" />
              <circle cx="36.9" cy="53" r="3.9" fill="#718096" />
              <circle cx="39.5" cy="29.9" r="3.9" fill="#718096" />
              <circle cx="54.9" cy="42.8" r="3.9" fill="#718096" />
              <circle cx="101.5" cy="120.5" r="3.9" fill="#718096" />
              <circle cx="102.8" cy="107.7" r="3.9" fill="#718096" />
              <circle cx="96.4" cy="96.1" r="3.9" fill="#718096" />
              <circle cx="109.3" cy="96.1" r="3.9" fill="#718096" />
              <circle cx="110.5" cy="71.6" r="3.9" fill="#718096" />
              <circle cx="115.7" cy="60" r="3.9" fill="#718096" />
              <circle cx="128.6" cy="60" r="3.9" fill="#718096" />
              <circle cx="101.5" cy="60" r="3.9" fill="#718096" />
              <circle cx="39.7" cy="66.8" r="3.9" fill="#718096" />
              <circle cx="91.2" cy="38.2" r="3.9" fill="#718096" />
              <circle cx="104.1" cy="38.2" r="3.9" fill="#718096" />
              <circle cx="111.8" cy="133.4" r="3.9" fill="#718096" />
              <circle cx="124.7" cy="121.8" r="3.9" fill="#718096" />
              <circle cx="118.3" cy="110.3" r="3.9" fill="#718096" />
              <circle cx="124.7" cy="48.5" r="3.9" fill="#718096" />
              <circle cx="118.3" cy="36.9" r="3.9" fill="#718096" />
              <circle cx="93.8" cy="133.4" r="3.9" fill="#718096" />
              <circle cx="92.5" cy="121.8" r="3.9" fill="#718096" />
              <circle cx="88.7" cy="109" r="3.9" fill="#718096" />
              <circle cx="67.1" cy="171.4" r="3.9" fill="#718096" />
              <circle cx="55.5" cy="171.4" r="3.9" fill="#718096" />
              <circle cx="67.1" cy="184.2" r="3.9" fill="#718096" />
              <circle cx="55.5" cy="184.2" r="3.9" fill="#718096" />
              <circle cx="67.1" cy="195.8" r="3.9" fill="#718096" />
              <circle cx="55.5" cy="195.8" r="3.9" fill="#718096" />
              <circle cx="67.1" cy="208.7" r="3.9" fill="#718096" />
              <circle cx="55.5" cy="208.7" r="3.9" fill="#718096" />
              <circle cx="149.2" cy="171.4" r="3.9" fill="#718096" />
              <circle cx="149.2" cy="184.2" r="3.9" fill="#718096" />
              <circle cx="149.2" cy="195.8" r="3.9" fill="#718096" />
              <circle cx="149.2" cy="208.7" r="3.9" fill="#718096" />
              <circle cx="209.2" cy="171.4" r="3.9" fill="#718096" />
              <circle cx="209.2" cy="184.2" r="3.9" fill="#718096" />
              <circle cx="138.9" cy="171.4" r="3.9" fill="#718096" />
              <circle cx="138.9" cy="184.2" r="3.9" fill="#718096" />
              <circle cx="138.9" cy="195.8" r="3.9" fill="#718096" />
              <circle cx="138.9" cy="208.7" r="3.9" fill="#718096" />
              <circle cx="116.1" cy="172.4" r="3.9" fill="#718096" />
              <circle cx="116.1" cy="185.2" r="3.9" fill="#718096" />
              <circle cx="116.1" cy="196.8" r="3.9" fill="#718096" />
              <circle cx="105.8" cy="172.4" r="3.9" fill="#718096" />
              <circle cx="105.8" cy="185.2" r="3.9" fill="#718096" />
              <circle cx="105.8" cy="196.8" r="3.9" fill="#718096" />
              <circle cx="122.1" cy="84.5" r="3.9" fill="#718096" />
              <circle cx="90" cy="84.5" r="3.9" fill="#718096" />
              <circle cx="101.5" cy="84.5" r="3.9" fill="#718096" />
              <circle cx="39.7" cy="88.6" r="3.9" fill="#718096" />
              <circle cx="31.9" cy="77" r="3.9" fill="#718096" />
              <circle cx="109.3" cy="49.8" r="3.9" fill="#718096" />
              <circle cx="124.7" cy="72.9" r="3.9" fill="#718096" />
              <circle cx="97.7" cy="27.9" r="3.9" fill="#718096" />
              <circle cx="185.2" cy="171.4" r="3.9" fill="#718096" />
              <circle cx="185.2" cy="184.2" r="3.9" fill="#718096" />
              <circle cx="185.2" cy="195.8" r="3.9" fill="#718096" />
              <circle cx="185.2" cy="208.7" r="3.9" fill="#718096" />
              <circle cx="174.9" cy="171.4" r="3.9" fill="#718096" />
              <circle cx="174.9" cy="184.2" r="3.9" fill="#718096" />
              <circle cx="174.9" cy="195.8" r="3.9" fill="#718096" />
              <circle cx="174.9" cy="208.7" r="3.9" fill="#718096" />
            </svg>
            <div class="text flex-col">
              <h6 class="text-2xl md:text-lg">Hamburg</h6>
              <p class="text-sm text-gray-500 text-left">in 35min.</p>
            </div>
          </div>
          <div id="sea" class="flex justify-center w-full items-center py-4 lg:px-2 xl:px-4">
            <svg class="w-16 fill-current mr-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M504.5 328.7c-22.1 0-33.3 4.3-44.1 8.5-10 3.8-19.5 7.5-38.8 7.5a91.9 91.9 0 0 1-38.7-7.5c-10.8-4.2-22-8.5-44.1-8.5s-33.3 4.3-44.2 8.5c-10 3.8-19.4 7.5-38.7 7.5-19.3 0-28.7-3.7-38.7-7.5-10.8-4.2-22-8.5-44.1-8.5s-33.3 4.3-44.1 8.5c-10 3.8-19.4 7.5-38.7 7.5-19.3 0-28.7-3.7-38.7-7.5-10.8-4.2-22-8.5-44.1-8.5a7.5 7.5 0 0 0 0 15c19.3 0 28.7 3.6 38.7 7.5 10.8 4.2 22 8.5 44 8.5 22.2 0 33.4-4.3 44.2-8.5 10-3.9 19.4-7.5 38.7-7.5 19.3 0 28.7 3.6 38.7 7.5 10.8 4.2 22 8.5 44.1 8.5s33.3-4.3 44.2-8.5c10-3.9 19.4-7.5 38.7-7.5 19.3 0 28.7 3.6 38.7 7.5 10.8 4.2 22 8.5 44.1 8.5s33.3-4.3 44.2-8.5c10-3.9 19.4-7.5 38.7-7.5a7.5 7.5 0 0 0 0-15zM471.4 373a7.5 7.5 0 0 0-9.7-4.3l-1.3.5c-4.6 1.8-8.8 3.4-13.9 4.8a7.5 7.5 0 0 0 3.8 14.5c5.9-1.6 10.8-3.4 15.5-5.3l1.3-.5a7.5 7.5 0 0 0 4.3-9.7zM416.6 376.7c-16-.6-24.6-4-33.7-7.5-10.8-4.1-22-8.5-44.1-8.5s-33.3 4.4-44.2 8.5c-10 4-19.4 7.6-38.7 7.6a91.8 91.8 0 0 1-38.7-7.6c-10.8-4.1-22-8.5-44.1-8.5s-33.3 4.4-44.1 8.5c-9 3.6-17.7 6.9-33.6 7.5a7.5 7.5 0 1 0 .6 15 104 104 0 0 0 38.4-8.5c10-3.8 19.4-7.5 38.7-7.5 19.3 0 28.7 3.7 38.7 7.5 10.8 4.2 22 8.6 44.1 8.6s33.3-4.4 44.2-8.6c10-3.8 19.4-7.5 38.7-7.5 19.3 0 28.7 3.7 38.7 7.5 9.8 3.9 20 7.8 38.6 8.5a7.5 7.5 0 0 0 .5-15zM338.8 392.8c-22.1 0-33.3 4.3-44.2 8.5-10 3.9-19.4 7.5-38.7 7.5-19.3 0-28.7-3.6-38.7-7.5-10.8-4.2-22-8.5-44.1-8.5a7.5 7.5 0 0 0 0 15c19.3 0 28.7 3.6 38.7 7.5 10.8 4.2 22 8.5 44.1 8.5s33.3-4.3 44.2-8.5c10-3.9 19.4-7.5 38.7-7.5a7.5 7.5 0 0 0 0-15zM65.5 374c-5-1.3-9.4-3-13.9-4.8a7.5 7.5 0 0 0-5.4 14c4.7 1.9 9.6 3.8 15.5 5.3a7.5 7.5 0 1 0 3.8-14.5zM354.3 227.7a119.9 119.9 0 0 0-217.7 77 7.5 7.5 0 0 0 15-1.1l-.3-7.5A104.8 104.8 0 0 1 342 236.3a7.5 7.5 0 0 0 12.3-8.6zM103.7 288.6H55.6a7.5 7.5 0 0 0 0 15h48a7.5 7.5 0 0 0 0-15zM256 88.2a7.5 7.5 0 0 0-7.5 7.5v48a7.5 7.5 0 1 0 15 0v-48c0-4.2-3.4-7.5-7.5-7.5zM403 149c-3-2.9-7.7-2.9-10.6 0l-34 34a7.5 7.5 0 1 0 10.6 10.7l34-34c3-3 3-7.7 0-10.6zM204.6 152.5l-6-14.8a7.5 7.5 0 0 0-14 5.7l6.2 14.8a7.5 7.5 0 1 0 13.8-5.7zM418.5 228.8a7.5 7.5 0 0 0-9.8-4l-14.9 6a7.5 7.5 0 1 0 5.8 14l14.8-6.2c3.8-1.6 5.6-6 4-9.8zM323.3 133.6a7.5 7.5 0 0 0-9.8 4l-6.1 14.9a7.5 7.5 0 0 0 13.8 5.7l6.1-14.8a7.5 7.5 0 0 0-4-9.8zM118.2 230.9l-14.9-6.2a7.5 7.5 0 1 0-5.7 13.9l14.8 6.1a7.5 7.5 0 0 0 9.8-4 7.5 7.5 0 0 0-4-9.8zM116.9 136.3a50 50 0 0 0-30.6 10.5 41.9 41.9 0 0 0-54.2 40c0 4 3.3 7.4 7.5 7.4h120.2c4.1 0 7.5-3.3 7.5-7.5a50.5 50.5 0 0 0-50.4-50.4zm-68.8 43a26.9 26.9 0 0 1 36.6-17.1c2.8 1.2 6 .6 8.2-1.4a35.3 35.3 0 0 1 58.6 18.4H48.1z" />
              <path
                d="M382 262.2c-4.2 0-8.4.7-12.4 2a50.5 50.5 0 0 0-81 40c0 4 3.3 7.4 7.5 7.4h120.2c4.2 0 7.5-3.4 7.5-7.5 0-23-18.8-41.9-41.8-41.9zm-77.6 34.4a35.5 35.5 0 0 1 58.6-18.4c2.2 2 5.4 2.6 8.2 1.4 3.4-1.6 7-2.4 10.8-2.4 12.2 0 22.5 8.2 25.8 19.4H304.4z" />
            </svg>
            <div class="text flex-col">
              <h6 class="text-2xl md:text-lg">Ostsee</h6>
              <p class="text-sm text-gray-500 text-left">in 35min.</p>
            </div>
          </div>
        </div>
        <div id="segeberg" class="flex justify-center w-full items-center py-4 lg:px-2 xl:px-4">
          <img class="w-16 fill-current mr-8 px-1" src="../assets/ind.svg" alt="">
          <div class="text flex-col">
            <h6 class="text-2xl md:text-lg">Bad Segeberg</h6>
            <p class="text-sm text-gray-500 text-left">in 20min.</p>
          </div>
        </div>
      </div>
    </div>
    <div id="kontakt" class="flex-col text-light_grey mt-24 w-full md:w-1/2">
      <h6 class="w-1/2 text-center text-lg">Wenn ihr Fragen habt ruft uns doch gerne an oder schreibt
        uns eine Email:</h6>
      <div class="icons flex w-1/2 md:w-1/4 mt-8 justify-between">
        <a target="_blank" href="mailto:witte-sh@t-online.de"><svg class="svg-lg fill-current"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 483.3 483.3">
            <path
              d="M424.3 57.8H59.1a59.2 59.2 0 0 0-59.1 59v249.6a59.2 59.2 0 0 0 59.1 59.2h365.1a59.2 59.2 0 0 0 59.1-59.2V117a59 59 0 0 0-59-59.3zm32.1 308.6a32.1 32.1 0 0 1-32.1 32.2H59.1A32.1 32.1 0 0 1 27 366.4V117a32.1 32.1 0 0 1 32.1-32.2h365.1a32.1 32.1 0 0 1 32.1 32.1v249.5h.1z" />
            <path
              d="M304.8 238.6l118.2-106c5.5-5 6-13.5 1-19.1-5-5.5-13.5-6-19.1-1l-163 146.3-31.8-28.5-.2-.3a20 20 0 0 0-2.2-1.9L78.3 112.3c-5.6-5-14.1-4.5-19.1 1.1-5 5.6-4.5 14.1 1.1 19.1l119.6 107L60.8 350.9a13.6 13.6 0 0 0 18.5 19.9l120.9-113.2L233 287a13.5 13.5 0 0 0 18 0l33.7-30.3 120.2 114.2a13.5 13.5 0 0 0 18.6-19.6L304.8 238.6z" />
          </svg>
        </a>
        <a target="_blank" href="tel:+4915755712506"><svg class="svg-lg fill-current" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 473.8 473.8">
            <path
              d="M374.5 293.5a46.6 46.6 0 0 0-33.8-15.5 48.2 48.2 0 0 0-34.2 15.4L274.9 325l-7.7-4a127 127 0 0 1-10-5.3 343.5 343.5 0 0 1-82.2-75 202.6 202.6 0 0 1-27-42.6c8.2-7.5 15.8-15.3 23.2-22.8l8.4-8.5c21-21 21-48.2 0-69.2l-27.3-27.3c-3.1-3-6.3-6.3-9.3-9.5-6-6.2-12.3-12.6-18.8-18.6-9.7-9.6-21.3-14.7-33.5-14.7s-24 5.1-34 14.7l-.2.2-34 34.3A73.2 73.2 0 0 0 .8 123.1c-2.4 29.2 6.2 56.4 12.8 74.2C29.8 241 54 281.5 90 325a470.6 470.6 0 0 0 156.7 122.7c23 11 53.7 23.8 88 26l6.3.2c23 0 42.5-8.3 57.7-24.8 0-.2.3-.3.4-.5 5.2-6.3 11.2-12 17.5-18 4.3-4.2 8.7-8.5 13-13a49.9 49.9 0 0 0 15-34.6 48 48 0 0 0-15.3-34.3l-55-55zm35.8 105.3c-.1 0-.1.1 0 0-4 4.2-8 8-12.2 12.2a263 263 0 0 0-19.3 20 48.2 48.2 0 0 1-37.6 16c-1.5 0-3.1 0-4.6-.2-29.7-1.9-57.3-13.5-78-23.4A444.2 444.2 0 0 1 111 307.8c-34.1-41-57-79-72-119.9-9.3-24.9-12.7-44.3-11.2-62.6 1-11.7 5.5-21.4 13.8-29.7l34-34A22.7 22.7 0 0 1 91 54.3c6.3 0 11.4 3.8 14.6 7l.3.3c6 5.7 11.9 11.6 18 18l9.5 9.6 27.3 27.3c10.6 10.6 10.6 20.4 0 31l-8.6 8.6a522 522 0 0 1-25.1 24.4l-.5.5c-8.6 8.6-7 17-5.2 22.7l.3 1a219.2 219.2 0 0 0 32.3 52.6v.1a367 367 0 0 0 88.9 80.8c4 2.6 8.3 4.7 12.3 6.7 3.6 1.8 7 3.5 9.9 5.3l1.2.7c3.4 1.7 6.6 2.5 9.9 2.5 8.3 0 13.5-5.2 15.2-6.9l34.2-34.2c3.4-3.4 8.8-7.5 15-7.5 6.3 0 11.4 4 14.5 7.3l.2.2 55 55.1c10.4 10.2 10.4 20.7.2 31.3zM256 112.7c26.3 4.4 50 16.8 69 35.8s31.4 42.8 35.9 69a13.4 13.4 0 0 0 13.3 11.2c.8 0 1.5 0 2.3-.2a13.5 13.5 0 0 0 11-15.6c-5.3-31.7-20.3-60.6-43.2-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3 3.7-15.6 11s3.5 14.4 10.9 15.6zM473.3 209c-9-52.2-33.5-99.7-71.3-137.5S316.7 9.1 264.5.2a13.4 13.4 0 1 0-4.4 26.6c46.6 8 89 30 122.9 63.7a226.5 226.5 0 0 1 63.7 123 13.4 13.4 0 0 0 13.3 11.1c.8 0 1.5 0 2.3-.2a13.2 13.2 0 0 0 11-15.4z" />
          </svg>
        </a>
      </div>
    </div>
    <div class="booking mt-16 mb-16">
      <a target="_blank"
        class="bg-red text-white hover:bg-red_highlight fair text-white py-4 px-8 text-xl border rounded"
        href="https://www.airbnb.de/rooms/36585379?check_in=2019-09-19&check_out=2019-09-21&source_impression_id=p3_1566743451_wdQ6rhsEmNvIhGOi">Buchen
        auf Airbnb
      </a>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";
  import 'swiper/dist/css/swiper.css'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    mixin as VueTimers
  } from 'vue-timers'

  export default {
    mixins: [VueTimers],
    components: {
      swiper,
      swiperSlide
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      },
      swiper2() {
        return this.$refs.mySwiper2.swiper
      }
    },
    data() {
      return {
        image_id: 1,
        image_id2: 1,
        rating_id: this.random_int(4),
        rezensionen: [{
            author: "Dirk Olaf",
            ort: "Riedstadt, Germany",
            text: "Sehr schönes Ambiente, Terrasse mit Blick auf den eigenen Teich, viel gute Tips zur Umgebung von den Gastgebern Maggie und Frank. Wir haben uns sehr wohl gefühlt!"
          },
          {
            author: "Vladimir",
            ort: "Wien, Österreich",
            text: "Geheimtipp zwischen Hamburg und Lübeck. Super schönes Haus mit dem Teich und dem Obstgarten. Das Haus ist Top mit allen notwendigen Utensilien ausgestattet. Es fehlt wirklich gar nichts! Sogar die Petrolimlame ist da. W-Lan Empfang ist so gut, dass man sogar draußen auf der Terrasse mit dem Teichblick arbeiten kann!!! Die Wohnung ist sehr hell, die Fenster mit Mückennetz ausgestattet.."
          },
          {
            author: "Arresu",
            ort: "Frankfurt Main, Germany",
            text: "Der Aufenthalt bei Margit war fantastisch. Nicht nur, dass alles in der Unterkunft bis ins kleinste Detail durchdacht war-sondern vorallem die Herzlichkeit und Offenheit von Margit und Frank! Wir wären zu gerne länger geblieben. Die Unterkunft ist gemütlich, geschmackvoll und sehr rein. Das Anwesen mit seinem großen Teich ist naturbelassen und lädt zum Verweilen ein.."
          },
          {
            author: "Sven",
            ort: "Lech, Germany",
            text: "Liebe zukünftige Gäste von Margrit und Frank, kann ich mich all dem vorhergesagten nur anschließen, könnt ihr bei einer Buchung bei den Beiden in Bad Oldesloe nichts falsch machen. Erwartet euch dort eine mit allem was es braucht ausgestattete, sehr saubere kleine und ruhige Wohnung, mit zwei lieben und herzlichen Gastgebern."
          },
          {
            author: "Usama",
            ort: "Rüsselsheim, Germany",
            text: "Wir hatten einen wundervollen Aufenthalt. Margrit und Frank sind tolle, aufmerksame, unkomplizierte und überaus freundliche Gastgeber. Die Lage der Wohnung ist schön und sehr ruhig. Die Ausstattung der Wohnung ließ keine Wünsche offen. Die Küche bietet alles, was man benötigt. Wir können sowohl Gastgeber als auch die Ferienwohnung wärmstens empfehlen."
          },
          {
            author: "Mareike",
            ort: "Kiel, Germany",
            text: "Die Unterkunft liegt sehr idyllisch, ist super eingerichtet und die Gastgeber sind einfach nur nett. Es war wirklich toll dort nach einem Arbeitstag auszuspannen und sich zu erholen. Wir kommen wieder."
          },
          {
            author: "Petra",
            ort: "Düsseldorf, Germany",
            text: "Die Begrüßung von Margrit war sehr herzlich. Die Wohnung ist gemütlich eingerichtet und es ist toll morgens ins Grüne und auf den Weiher zu gucken. Die neue Küche ist klasse, Wlan hat sehr gut funktioniert. Für uns war alles genau richtig. Nicht weit von der Autobahn und doch im Grünen, eine klare Empfehlung."
          }
        ],
        swiperOption: {
          centeredSlides: true,
          autoplay: 10,
          loop: true,
          direction: "horizontal",
          pagination: '.swiper-pagination',
          slidesPerView: 1,
          paginationClickable: true,
          spaceBetween: 30,
          keyboardControl: true,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev'
        }
      }
    },
    methods: {
      push_rating() {
        if (this.rating_id < 3) {
          this.rating_id += 1;
        } else {
          this.rating_id = 0;
        }
      },
      push_image() {
        if ($(window).width() < 960) {
          var upperLimit = 8;
        } else {
          var upperLimit = 4;
        }
        if (this.image_id < upperLimit) {
          this.image_id++;
        } else {
          this.image_id = 1;
        }
        this.swiper.slideTo(this.image_id, 1000, false)
      },
      push_image2() {
        if (this.image_id2 < 3) {
          this.image_id2++;
        } else {
          this.image_id2 = 1;
        }
        this.swiper2.slideTo(this.image_id2, 1000, false)
      },
      random_int(max) {
        return Math.floor(Math.random() * Math.floor(max));
      },
      getImageData(id) {
        if ($(window).width() < 960) {
          return [require("../assets/images/out1xx.jpg"), require("../assets/images/air2.jpg"), require(
            "../assets/images/air7.jpg"), require("../assets/images/out5.jpg"), require(
            "../assets/images/air1.jpg"), require("../assets/images/out4.jpg"), require(
            "../assets/images/air6.jpg")];
        } else {
          if (id == 1) {
            return [require("../assets/images/out1xx.jpg"), require("../assets/images/air2.jpg"), require(
              "../assets/images/air7.jpg"), require("../assets/images/out5.jpg")];
          } else {
            return [require(
              "../assets/images/air1.jpg"), require("../assets/images/out4.jpg"), require(
              "../assets/images/air6.jpg")]
          }
        }
      }
    },
    timers: {
      push_rating: {
        time: 11300,
        autostart: true,
        repeat: true
      },
      push_image: {
        time: 7700,
        autostart: true,
        repeat: true
      },
      push_image2: {
        time: 9300,
        autostart: true,
        repeat: true
      }
    }
  }
</script>